import { createApp } from 'vue'
import App from './App.vue'
import { initAnalytics } from './lib/analytics'
import { isCaptureMode } from './lib/capture'
import { router } from './router'
import './styles.css'
import appIconUrl from './assets/povli-app-icon-96.webp'

const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
if (favicon) {
  favicon.href = appIconUrl
  favicon.type = 'image/webp'
}

if (!isCaptureMode()) initAnalytics()
createApp(App).use(router).mount('#app')
